import { render, staticRenderFns } from "./TbsErrorHeader.vue?vue&type=template&id=e5cc1c2c&scoped=true&"
import script from "./TbsErrorHeader.vue?vue&type=script&lang=js&"
export * from "./TbsErrorHeader.vue?vue&type=script&lang=js&"
import style0 from "./TbsErrorHeader.vue?vue&type=style&index=0&id=e5cc1c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cc1c2c",
  null
  
)

export default component.exports